var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  overflow: hidden;\n'], ['\n  position: absolute;\n  clip: rect(1px, 1px, 1px, 1px);\n  overflow: hidden;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  position: relative;\n  ', ';\n  ', ';\n  ', ';\n  ', ';\n']);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import { string, node } from 'prop-types';
import styled from 'styled-components';

// Styles for Title, mostly used for A11y
var Title = styled.span(_templateObject);

// Styles for SVG
var Wrapper = styled.svg(_templateObject2, function (props) {
  return props.fill && 'fill: ' + props.fill + ';';
}, function (props) {
  return props.height && 'height: ' + props.height + ';';
}, function (props) {
  return props.width && 'width: ' + props.width + ';';
}, function (props) {
  return props.margin && 'margin: ' + props.margin + ';';
});

export default function StyledIcon(props) {
  var children = props.children,
      title = props.title,
      automationId = props.automationId,
      color = props.color,
      restProps = _objectWithoutProperties(props, ['children', 'title', 'automationId', 'color']);

  return React.createElement(
    React.Fragment,
    null,
    React.createElement(
      Wrapper,
      _extends({}, restProps, {
        focusable: 'false',
        'aria-hidden': true,
        'data-automation-id': automationId,
        fill: color
      }),
      children
    ),
    title && React.createElement(
      Title,
      null,
      title
    )
  );
}

StyledIcon.propTypes = {
  /**
   * Elements passed into the SVG Icon.
   */
  children: node.isRequired,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  title: string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an svg element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the svg will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: string,
  /**
    * Automation ID prop for allowing easier access to elements while running functional tests.
    */
  automationId: string,
  /**
   * Used for filling the svg
   */
  color: string,
  /**
   * To determine height of the icon
   */
  height: string,
  /**
   * To determine width of the icon
   */
  width: string,
  /**
   * To determine margin of the icon
   */
  margin: string
};

StyledIcon.defaultProps = {
  viewBox: '0 0 20 20',
  title: '',
  automationId: 'idsSvgIcon',
  margin: undefined,
  color: undefined,
  width: undefined,
  height: undefined
};